import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";

export default function AuctionApply() {
  const laung = localStorage.getItem("laung");
  const path = "Assets/scss/FirstTimeUsers.module.scss";
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  return (
    <div className="col-md-8 mx-auto signuppage">
      <div className="col-md-6 mx-auto text-center">
        <p>Order summary</p>
        <h1>Select payment methods.</h1>
      </div>
      <div className="visit">
        <button
          onClick={() => navigate(`/${lan}/auctionapply`)}
          className="btn"
        >
          Save and make payment
        </button>
      </div>
    </div>
  );
}
